import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

export const CallToActionBlock: React.FC<CTABlockProps> = ({ links, richText, media }) => {
  return (
    <div
      className={'bg-cover'}
      style={{ backgroundImage: typeof media === 'object' ? `url('${media.url}')` : '' }}
    >
      <div className="flex flex-col items-center justify-center text-white text-center h-[100dvh]">
        <div className="flex items-center">
          {richText && (
            <RichText className="mb-0" content={richText} enableProse={true} enableGutter={false} />
          )}
        </div>
        <div className="flex flex-col gap-8 mt-4">
          {(links || []).map(({ link }, i) => {
            return <CMSLink key={i} size="lg" {...link} />
          })}
        </div>
      </div>
    </div>
  )
}
